import { Fragment, useEffect, useState } from "react";
import Badge from "./badge";
import SeeAllBadgesModal from "./seeAllBadgesModal";
import SeeAll from "../../assets/images/seeall.svg";
import { useSelector } from "react-redux";

function BadgeSection(props) {
    const windowSize = useSelector(state => state.data.windowSize);
    const [badgePages, setBadgePages] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [showSeeAllModal, setShowSeeAllModal] = useState(false);
    const [badgesPerPage, setBadgesPerPage] = useState(windowSize === "large" ? 5 : 4);
    const [scrollSize, setScrollSize] = useState(980);
    const badgeContainer = props.name ? props.name : props.section.name;
    const badgeContainerId = badgeContainer ? badgeContainer.replace(/[^A-Za-z0-9]/g, "").toLowerCase() : "";
    const maxPages = 4;
    const pages = props.section.badges ? Math.ceil(props.section.badges.length / badgesPerPage) : 1;
    const showSeeAll = props.section.badges && props.section.badges.length > badgesPerPage * maxPages;

    useEffect(() => {
        let bpp = windowSize === "large" ? 5 : 4;
        let result = [];
        let badgeArray = props.section.badges ? [...props.section.badges] : [];
        while (badgeArray.length > 0) {
            result.push(badgeArray.splice(0, bpp));
        }
        setScrollSize(windowSize === "large" ? 980 : windowSize === "medium" ? 980 : 292);
        setBadgesPerPage(bpp);
        setBadgePages(result);
    }, [props.section, windowSize]);

    useEffect(() => {
        const container = document.querySelector(`.${badgeContainerId}-container`);
        container.scrollTo({
            left: currentPage * scrollSize,
            behavior: "smooth",
        });
    }, [currentPage, scrollSize, badgeContainerId]);

    const next = () => {
        setCurrentPage(currentPage < maxPages ? currentPage + 1 : currentPage);
    };

    const back = () => {
        setCurrentPage(currentPage <= 0 ? 0 : currentPage - 1);
    };

    const getPages = () => {
        let pages = [];
        let maxPageCount = windowSize === "small" ? maxPages + 1 : maxPages;
        let limit = badgePages.length > maxPageCount - 1 ? maxPageCount : badgePages.length;
        for (let i = 0; i < limit; i++) {
            pages.push(
                <div className="page-control-radio" onClick={() => handleDotClick(i)} key={i}>
                    <div className={`outer-radio ${i === currentPage ? 'active' : ''}`}>
                        {i === currentPage && <div className="inner-radio"></div>}
                    </div>
                </div>
            );
        }
        return pages;
    };

    const handleDotClick = page => {
        setCurrentPage(page);
        const container = document.querySelector(`.${badgeContainerId}-container`);
        container.scrollTo({
            left: page * scrollSize,
            behavior: "smooth",
        });
    };

    const handleScroll = e => {
        if (e.target.scrollLeft % scrollSize === 0) {
            setCurrentPage(e.target.scrollLeft / scrollSize);
        }
    };

    return (
        <div className="badge-section">
            {showSeeAllModal && <SeeAllBadgesModal close={() => setShowSeeAllModal(false)} section={props.section} />}
            <div className="badge-section-header">
                <div className="left">
                    <p className="badge-section-name">
                        {props.title ? props.title : props.section && props.section.name ? props.section.name : ""}
                        {showSeeAll && <wbr />}
                        {!props.hideCount && props.section && props.section.counts && parseInt(String(props.section.counts.total)) > 0 &&
                            <span className={`badge-section-earned-count ${showSeeAll ? "wrap" : ""}`}>
                                {`(${props.section.counts.earned} of ${props.section.counts.total} Earned)`}
                            </span>
                        }
                    </p>
                </div>
                {showSeeAll &&
                    <div className="right">
                        <div className="badge-section-see-all" onClick={() => setShowSeeAllModal(true)}>
                            See All<img alt="See All" src={SeeAll}></img>
                        </div>
                    </div>
                }
            </div>
            <div className="badge-section-desc">
                {props.renderDesc ? props.renderDesc() : props.section && props.section.desc ? props.section.desc : ""}
            </div>
            <div className="badge-section-body">
                {currentPage !== 0 && <div className="badge-section-control">
                    <button className="control-button back" onClick={back}></button>
                </div>}
                <div className={`badge-container-area ${badgeContainerId}-container`} onScrollCapture={handleScroll}>
                    {badgePages.slice(0, maxPages).map((page, i) =>
                        <div key={i} className={`badge-container ${currentPage + 1 === i ? "next" : currentPage - 1 === i ? "last" : currentPage === i ? "current" : ""}`}>
                            {page.length > 0 && page.map((badge, j) =>
                                <Fragment key={j}>
                                    <Badge badge={badge} />
                                </Fragment>
                            )}
                        </div>
                    )}
                    {windowSize === "small" && showSeeAll &&
                        <div className="badge-container see-all-mobile">
                            <button onClick={() => setShowSeeAllModal(true)}>See All Category Badges</button>
                        </div>
                    }
                </div>
                {badgePages.length > 1 && currentPage < badgePages.length - 1 && currentPage < maxPages - 1 &&
                    <div className="badge-section-control">
                        <button className="control-button next" onClick={next}></button>
                    </div>
                }
            </div>
            {pages > 1 &&
                <div className="page-control">
                    {getPages()}
                </div>
            }
            {props.renderFooter &&
                <div className="badge-section-footer">
                    {props.renderFooter ? props.renderFooter() : ""}
                </div>
            }
        </div>
    );
}

export default BadgeSection;
